<template>
  <div class="container users-setting">
    <panel
      Title=" وضعیت کاربران "
      Des="از طریق این منو میتوانید وضعیت ورود کاربران به اینترنت بانک را مشاهده کنید و وضعیت آنها را تغییر دهید.."
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <loading v-if="loadingRender"></loading>

    <div class="row">
      <div class="col-xl-2 d-none d-xl-block"></div>
      <div class="col-xl-8 col-12">
        <net-pa-card>
          <template v-slot:header>
            <h6><i class="fas fa-users"></i> وضعیت کاربران</h6>
          </template>
          <template v-slot:content>
            <form
              id="searchAza"
              class="users-setting-search"
              @submit.prevent="SearchByCodeMeli"
            >
              <div class="users-setting-field">
                <label for="CodeMeli">کدملی کاربر</label>
                <input
                  type="text"
                  @keypress="$ValidNumber($event, 14)"
                  id="CodeMeli"
                  class="form-control text-left required-CodeMeli users-setting-input"
                  v-model="CodeMeli"
                  placeholder="۱۰ رقم"
                  autocomplete="off"
                  inputmode="numeric"
                  dir="ltr"
                />
              </div>
              <div class="users-setting-field users-setting-field--captcha">
                <span class="users-setting-label">کد امنیتی</span>
                <CaptchaBox
                  ref="captchaRef"
                  @update="onCaptchaValid"
                ></CaptchaBox>
              </div>
              <div class="users-setting-field users-setting-field--action">
                <button
                  type="submit"
                  :disabled="!CaptchaValid || loadingRender"
                  class="btn users-setting-search-btn"
                >
                  <i class="fas fa-search" aria-hidden="true"></i>
                  جستوجوی مشتری
                </button>
              </div>
            </form>

            <div
              v-if="searchedUSer == null"
              class="users-setting-hint"
              role="status"
            >
              <i class="fas fa-user-shield" aria-hidden="true"></i>
              کد ملی کاربر را وارد کنید تا وضعیت ورود نمایش داده شود.
            </div>

            <div
              v-else
              class="users-setting-result pulse"
              id="animate"
            >
              <div class="users-setting-result__head">
                <div>
                  <span class="users-setting-kicker">مشخصات کاربر</span>
                  <strong class="users-setting-name">{{ Moshakhasat }}</strong>
                </div>
                <span
                  class="users-setting-badge"
                  :class="
                    VaziatKarbar
                      ? 'users-setting-badge--off'
                      : 'users-setting-badge--on'
                  "
                >
                  <i
                    :class="VaziatKarbar ? 'fas fa-times' : 'fas fa-check'"
                    aria-hidden="true"
                  ></i>
                  {{ VaziatKarbar ? "غیرفعال" : "فعال" }}
                </span>
              </div>

              <div class="users-setting-facts">
                <div class="users-setting-fact">
                  <small>شماره مشتری</small>
                  <span dir="ltr">{{ ShomareOzv || "—" }}</span>
                </div>
                <div class="users-setting-fact">
                  <small>تاریخ آخرین ورود</small>
                  <span dir="ltr">{{ TarixlastEnter || "ثبت نشده" }}</span>
                </div>
                <div
                  class="users-setting-fact"
                  :class="{ 'is-alert': hasFailedLogins }"
                >
                  <small>دفعات ورود ناموفق</small>
                  <span dir="ltr">{{ CountAuthFailed || "0" }}</span>
                </div>
                <div class="users-setting-fact">
                  <small>وضعیت کاربر</small>
                  <span :class="VaziatKarbar ? 'text-danger' : 'text-success'">
                    {{ VaziatKarbar ? "قفل ورود" : "مجاز به ورود" }}
                  </span>
                </div>
              </div>

              <label
                class="users-setting-switch"
                :class="{
                  'is-disabled': CodeMeli == '' || loadingRender,
                }"
              >
                <span>وضعیت ورود</span>
                <span class="users-setting-switch__ctrl">
                  <em
                    class="users-setting-switch__state"
                    :class="VaziatKarbar ? 'is-off' : 'is-on'"
                    >{{ VaziatKarbar ? "غیرفعال" : "فعال" }}</em
                  >
                  <span class="users-setting-switch__track-wrap">
                    <input
                      type="checkbox"
                      :checked="!VaziatKarbar"
                      :disabled="CodeMeli == '' || loadingRender"
                      @change="changevaziat()"
                      aria-label="فعال یا غیرفعال کردن کاربر"
                    />
                    <span
                      class="users-setting-switch__track"
                      aria-hidden="true"
                    ></span>
                  </span>
                </span>
              </label>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-xl-2 d-none d-xl-block"></div>
    </div>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import loading from "../Tools/NetPa/Loading.vue";
import CaptchaBox from "../CmpLogin/CaptchaBox.vue";
export default {
  data() {
    return {
      captchaText: "",
      captchaId: "",
      CaptchaValid: false,
      CodeMeli: "",
      Moshakhasat: "",
      ShomareOzv: "",
      TarixlastEnter: "",
      CountAuthFailed: "",
      VaziatKarbar: "",
      searchedUSer: null,
      loadingRender: false,
    };
  },
  components: { NetPaCard, Panel, loading, CaptchaBox },
  computed: {
    hasFailedLogins() {
      const n = Number(this.CountAuthFailed);
      return Number.isFinite(n) ? n > 0 : Boolean(this.CountAuthFailed);
    },
  },
  methods: {
    onCaptchaValid({ valid, captchaId, userInput }) {
      this.CaptchaValid = valid;
      this.captchaId = captchaId;
      this.captchaText = userInput;
    },
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
    },
    applyUserData(data) {
      this.searchedUSer = data.id;
      this.Moshakhasat = data.ozvName + " " + data.ozvFamily;
      this.ShomareOzv = data.shomareOzv;
      this.TarixlastEnter = data.axarinVorodBeSite;
      this.CountAuthFailed = data.countAuthFailed;
      this.VaziatKarbar = data.isLockForLogin;
    },
    SearchByCodeMeli() {
      if (!this.CaptchaValid || this.loadingRender) return;
      if (this.$requiredCodeMeli("searchAza")) {
        this.loadingRender = true;
        var formdata = new FormData();
        formdata.append("Codemeli", this.CodeMeli);
        formdata.append("userInput", this.captchaText);
        formdata.append("captchaId", this.captchaId);
        var DataAxiosGetuser = {
          ArryfildValue: formdata,
          Method: "Post",
          Action: "getUserByCodeMeli",
          Token: this.$session.get("TokenNetPa"),
        };
        this.$PostFormData(DataAxiosGetuser)
          .then((data) => {
            this.loadingRender = false;
            if (data.status == "OK") {
              this.applyUserData(data.data);
              this.$mySweetDefaultTost("عملیات موفق", "", "success", 2000);
              this.refreshCaptcha();
            } else {
              this.searchedUSer = null;
              this.$mySweetDefaultTost("عملیات ناموفق", data.msg, "error", 2000);
              this.refreshCaptcha();
            }
          })
          .catch(() => {
            this.loadingRender = false;
            this.refreshCaptcha();
            this.$mySweetDefaultTost(
              "خطا",
              "ارتباط با سرور برقرار نشد. دوباره تلاش کنید.",
              "error",
              2000,
            );
          });
      }
    },
    changevaziat() {
      this.loadingRender = true;
      var formdata = new FormData();
      formdata.append("Id", this.searchedUSer);
      formdata.append("countAuth", 0);
      var DataAxiosGetuser = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "AxarinVorod/ChangeVaziat",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxiosGetuser)
        .then((data) => {
          this.loadingRender = false;
          if (data.status == "OK") {
            this.applyUserData(data.data);
            this.$mySweetDefaultTost("عملیات موفق", "", "success", 2000);
            this.refreshCaptcha();
          } else {
            this.searchedUSer = null;
            this.$mySweetDefaultTost(
              " خطا",
              "مشکلی در بروز رسانی اطلاعات بوجود آمده است. دوباره تلاش کنید.",
              "error",
              2000,
            );
            this.refreshCaptcha();
          }
        })
        .catch(() => {
          this.loadingRender = false;
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            "ارتباط با سرور برقرار نشد. دوباره تلاش کنید.",
            "error",
            2000,
          );
        });
    },
  },
};
</script>
<style scoped>
.users-setting {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-border: #dbe5eb;
  --bnp-surface: #f8fafc;
  --bnp-radius: 14px;
}

/* شکستن خط بر اساس عرض خود کارت (نه viewport)؛ در تبلت با سایدبار، کارت باریک است */
.users-setting-search {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
  margin-bottom: 8px;
}

.users-setting-field {
  flex: 1.1 1 170px;
  min-width: 0;
  text-align: right;
}

.users-setting-field--captcha {
  flex: 1.4 1 220px;
}

.users-setting-field--action {
  flex: 1 0 150px;
}

.users-setting-field label,
.users-setting-label {
  display: block;
  margin-bottom: 8px;
  color: #31465f;
  font-size: 13px;
  font-weight: 700;
}

.users-setting-input {
  height: 44px;
  color: var(--bnp-text-primary);
  font-size: 14px;
  border: 1px solid var(--bnp-border);
  border-radius: 12px;
  background: var(--bnp-surface);
  box-shadow: none;
}

.users-setting-input:focus {
  border-color: var(--bnp-brand-cyan);
  background: #fff;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.users-setting-field--action {
  display: flex;
  align-items: flex-end;
}

.users-setting-search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 44px;
  padding: 10px 16px;
  color: #fff !important;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  box-shadow: 0 10px 20px rgba(41, 52, 95, 0.16);
}

.users-setting-search-btn:not(:disabled):hover {
  color: #fff !important;
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(41, 52, 95, 0.22);
}

.users-setting-search-btn:disabled {
  cursor: not-allowed;
  opacity: 0.62;
}

.users-setting-field--captcha ::v-deep .input-group {
  margin-bottom: 0 !important;
}

.users-setting-field--captcha ::v-deep .form-control {
  height: 44px;
  min-height: 44px;
  font-size: 13px;
  text-align: center;
  border: 1px solid var(--bnp-border);
  border-radius: 12px 0 0 12px;
  background: var(--bnp-surface);
  box-shadow: none;
}

.users-setting-field--captcha ::v-deep .form-control:focus {
  border-color: var(--bnp-brand-cyan);
  background: #fff;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.users-setting-field--captcha ::v-deep .input-group-text {
  height: 44px;
  padding: 0 !important;
  overflow: hidden;
  border: 1px solid var(--bnp-border);
  border-right: 0;
  border-radius: 0 12px 12px 0;
  background: #fff;
}

.users-setting-field--captcha ::v-deep .input-group-text img {
  height: 44px;
  width: auto;
}

.users-setting-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 18px;
  padding: 16px 12px;
  color: var(--bnp-text-secondary);
  font-size: 13px;
  text-align: center;
  border: 1px dashed var(--bnp-border);
  border-radius: var(--bnp-radius);
  background: var(--bnp-surface);
}

.users-setting-hint i {
  color: var(--bnp-brand-indigo);
}

.users-setting-result {
  margin-top: 18px;
  padding: 16px;
  border: 1px solid var(--bnp-border);
  border-radius: 16px;
  background:
    radial-gradient(circle at 100% 0%, rgba(5, 184, 200, 0.1), transparent 42%),
    radial-gradient(circle at 0% 100%, rgba(141, 88, 164, 0.08), transparent 46%),
    #fff;
}

.users-setting-result__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.users-setting-kicker {
  display: block;
  margin-bottom: 4px;
  color: var(--bnp-text-secondary);
  font-size: 12px;
}

.users-setting-name {
  display: block;
  color: var(--bnp-brand-navy);
  font-size: 16px;
  font-weight: 800;
}

.users-setting-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 700;
  border-radius: 999px;
  white-space: nowrap;
}

.users-setting-badge--on {
  color: #0d6b53;
  background: rgba(5, 184, 200, 0.14);
}

.users-setting-badge--off {
  color: #9b2d42;
  background: rgba(180, 79, 70, 0.12);
}

.users-setting-facts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.users-setting-fact {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  padding: 12px;
  border: 1px solid var(--bnp-border);
  border-radius: 12px;
  background: var(--bnp-surface);
}

.users-setting-fact.is-alert {
  border-color: rgba(180, 79, 70, 0.28);
  background: #fcefed;
}

.users-setting-fact small {
  color: var(--bnp-text-secondary);
  font-size: 12px;
}

.users-setting-fact span {
  color: var(--bnp-text-primary);
  font-size: 14px;
  font-weight: 700;
  word-break: break-word;
}

.users-setting-fact.is-alert span {
  color: #b44f46;
}

.users-setting-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 48px;
  margin-top: 14px;
  padding: 10px 14px;
  color: #31465f;
  font-size: 13px;
  font-weight: 700;
  border: 1px solid #e8eef2;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
}

.users-setting-switch.is-disabled {
  cursor: not-allowed;
  opacity: 0.62;
}

.users-setting-switch__ctrl {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.users-setting-switch__state {
  min-width: 52px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  text-align: center;
}

.users-setting-switch__state.is-on {
  color: #068997;
}

.users-setting-switch__state.is-off {
  color: #8b98a8;
}

.users-setting-switch__track-wrap {
  position: relative;
  display: inline-flex;
  margin: 0;
}

.users-setting-switch input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  opacity: 0;
}

.users-setting-switch__track {
  position: relative;
  display: block;
  width: 44px;
  height: 26px;
  border-radius: 999px;
  background: #d5dee6;
  transition: background 180ms ease;
}

.users-setting-switch__track::after {
  content: "";
  position: absolute;
  top: 3px;
  right: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(19, 36, 58, 0.22);
  transition: transform 180ms ease;
}

.users-setting-switch input:checked + .users-setting-switch__track {
  background: linear-gradient(110deg, #29345f, #05b8c8);
}

.users-setting-switch input:checked + .users-setting-switch__track::after {
  transform: translateX(-18px);
}

.users-setting-switch input:focus-visible + .users-setting-switch__track {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.22);
}

.users-setting-switch input:disabled + .users-setting-switch__track {
  cursor: not-allowed;
  opacity: 0.55;
}

.pulse {
  -webkit-animation-name: pulse;
  animation-name: pulse;
  -webkit-animation-duration: 0.7s;
  animation-duration: 0.7s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.02, 1.02, 1.02);
    transform: scale3d(1.02, 1.02, 1.02);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.02, 1.02, 1.02);
    transform: scale3d(1.02, 1.02, 1.02);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@media (max-width: 767.98px) {
  .users-setting-field,
  .users-setting-field--captcha,
  .users-setting-field--action {
    flex-basis: 100%;
  }

  .users-setting-facts {
    grid-template-columns: 1fr;
  }

  .users-setting-toggle {
    max-width: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .users-setting-search-btn,
  .users-setting-toggle,
  .pulse {
    animation: none;
    transform: none;
  }
}
</style>
